import React, { ReactElement, FC } from 'react'

const BrandHiFiIcons: FC = (): ReactElement => {
  return <div>Placeholder Component</div>
}

export default BrandHiFiIcons
